import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-comment-box',
  templateUrl: './comment-box.component.html',
  styleUrls: ['./comment-box.component.scss'],
})
export class CommentBoxComponent implements OnInit {
  @Input() isStandaloneMode: any = false;
  @Input() modalLabel: any = 'Comment';
  @Input() initialComment: any = '';
  @Input() commentRequired: any = true;
  @Input() maxCommentLength: any = 500;

  @Output() save = new EventEmitter<{ comment: string; id: any; statusId: any }>();

  commentForm!: FormGroup;
  submitted: any = false;
  data: any = '';

  constructor(private fb: FormBuilder, private modal: CustomModalService) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeModalMode();
  }

  private initializeModalMode() {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'] ?? this.modalLabel;
    this.data = this.modal?.modalService?.config?.initialState?.['data'];
  }
  private initializeForm() {
    this.commentForm = this.fb.group({
      comment: [
        this.initialComment,
        [
          Validators.required,
          Validators.maxLength(this.maxCommentLength),
          (control: { value: string }) => (control.value?.trim() ? null : { required: true }),
        ],
      ],
    });
  }

  onSave() {
    this.submitted = true;

    this.markFormGroupTouched(this.commentForm);

    if (this.commentForm.valid) {
      const formData = this.commentForm.value;
      const comment = formData.comment;

      this.data.comment = comment;
      this.save.emit(this.data);
    }
  }

  onClose() {
    this.modal.close();
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  get f() {
    return this.commentForm.controls;
  }

  getCommentCharCount(): number {
    const comment = this.commentForm.get('comment')?.value;
    return comment ? comment.length : 0;
  }

  isCommentNearMaxLength(): boolean {
    const currentLength = this.getCommentCharCount();
    return currentLength > this.maxCommentLength * 0.8;
  }

  getRemainingCharacters(): number {
    return this.maxCommentLength - this.getCommentCharCount();
  }

  isSaveDisabled(): boolean {
    return this.submitted && this.commentForm.invalid;
  }
}
